import Data from './data'

export default {
    schema: ({ url, baseURL, regex }) => {
        const path = url.replace(baseURL, '')
        const [, entityKey] = path.match(regex)
        const response = Data[entityKey]

        if (!response) return [404]
        return [200, response]
    },

    transforms: () => [200, Data.transforms],
    styles: () => [200, Data.styles],
    validators: () => [200, Data.validators],
    create: params => [200, Data.params],
}
